import { getTrackerField } from '@nobia/zeus-components/lib/analytics'
import { useAuth } from '@nobia/zeus-components/lib/auth'
import queryString from '@nobia/zeus-components/lib/helpers/queryString'
import { Route } from '@nobia/zeus-components/lib/router'
import settings from '@nobia/zeus-components/lib/settings'
import { getUtmCookie, buildUtmQueryAfterSource } from '../utils/login'
import React from 'react'

import { Box } from '../components/Box/Box'

function ProtectedRoute(props) {
  const auth = useAuth()
  const { status, profile } = auth
  const utmCookie = getUtmCookie()
  const utmQuery = buildUtmQueryAfterSource(utmCookie)
  const { path = '', query } = settings.login ?? {};

  if (status === 'unauthenticated') {
    /* eslint-disable no-console */
    console.log(
      `Unauthenticated. Redirecting to: ${JSON.stringify({
        ...queryString.parse(getTrackerField('linkerParam')),
        ReturnUrl: location.pathname,
        forced: true,
        provider: query?.provider,
      })}. Auth is ${JSON.stringify(auth)}`
    )
    const params = new URLSearchParams({
      ...queryString.parse(getTrackerField('linkerParam')),
      ReturnUrl: location.pathname,
      forced: true,
      provider: query?.provider,
    })
    window.location.href = `${path}?${params}${utmQuery}`
    return <></>
  }

  if (!profile.roles.includes('customer')) {
    return (
      <Box m="l" display="flex" flexDirection="column">
        <p>This is not a customer account</p>
        <span>Email: {profile.email}</span>
        <span>Username: {profile.username}</span>
        {profile.roles.includes('staff') && (
          <Box mt="s">
            <a href="/sales-tool/">Go to Sales Tool</a>
          </Box>
        )}
        <Box mt="s">
          <a href={settings.logout.path}>Logout</a>
        </Box>
      </Box>
    )
  }

  return <Route {...props} />
}

export default ProtectedRoute
